import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    searchMeta: null,
    filters: [],
    searchStatus: null,
};

const getters = {
    filters(state) {
        return state.filters;
    },
};

const mutations = {
    setSearchMeta(state, meta) {
        state.searchMeta = meta;
    },

    setFilters(state, filters) {
        state.filters = filters;
    },

    addSearchMetaFilter(state, filter) {
        if (state.searchMeta && state.searchMeta.filters) {
            state.searchMeta.filters.push(filter);
        }
    },

    setSearchStatus(state, data) {
        state.searchStatus = data;
    },
};

const actions = {
    getSearchMeta({ commit, dispatch }, supplier) {
        let route = Laroute.route(
            'inventory.stock-movement.search.meta',
            supplier,
        );

        startLoading(dispatch, 'get-stock-movement-meta');

        return axios
            .get(route)
            .then(res => {
                commit('setSearchMeta', res.data);
                endLoading(dispatch, 'get-stock-movement-meta');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-stock-movement-meta');
                throw err;
            });
    },

    getSearchMetaIfNecessary({ commit, dispatch }, supplier) {
        if (!state.searchMeta) {
            return dispatch('getSearchMeta', supplier);
        }

        return Promise.resolve(state.searchMeta);
    },

    getSearchStatus({ commit, dispatch }) {
        let route = Laroute.route('inventory.stock-movement.search.status');

        startLoading(dispatch, 'get-stock-movement-status');

        return axios
            .get(route)
            .then(res => {
                commit('setSearchStatus', res.data);
                endLoading(dispatch, 'get-stock-movement-status');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-stock-movement-status');
                throw err;
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
